import React from 'react';

function Logo({ size = 40, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Fond arrondi */}
      <rect
        x="5"
        y="5"
        width="90"
        height="90"
        rx="15"
        fill="#3a86ff"
      />
      
      {/* Lignes représentant les plaques */}
      <rect
        x="20"
        y="25"
        width="60"
        height="12"
        rx="2"
        fill="white"
        opacity="0.9"
      />
      <rect
        x="20"
        y="42"
        width="45"
        height="12"
        rx="2"
        fill="white"
        opacity="0.9"
      />
      <rect
        x="20"
        y="59"
        width="55"
        height="12"
        rx="2"
        fill="white"
        opacity="0.9"
      />
      
      {/* Petit carré représentant une chute/optimisation */}
      <rect
        x="70"
        y="42"
        width="10"
        height="12"
        rx="2"
        fill="#06d6a0"
        opacity="0.9"
      />
      
      {/* Ciseaux / outil de découpe stylisé */}
      <path
        d="M75 70 L85 80 M85 70 L75 80"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.8"
      />
    </svg>
  );
}

export default Logo;
